<app-page-body [class]="'tw-pt-2'" *ngIf="!isVisibleHelpPage">
  <!-- header -->
  <app-page-header
    custom-header
    [title]="pageVocabs + 'title' | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div class="card-toolbar" after-btns>
      @if (!formPageConfig?.isEditMode) {
      <!-- open sendQueue -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'sendQueue'
            : 'currentUserSendQueue'
        "
        icon="mdi-email-multiple-outline"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.sendQueue.title'
            : 'pages.sendQueue.userTitle'
        "
        btnColor="btn-light"
      ></page-header-btn>

      <!-- open outboxMessages -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'userOutboxMessages'
            : 'currentUserOutboxMessages'
        "
        icon="mdi-inbox-arrow-up"
        iconSize="mdi-22px"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.outboxMessages.title'
            : 'pages.outboxMessages.userTitle'
        "
        btnColor="btn-light-info"
      ></page-header-btn>
      }
    </div>
  </app-page-header>

  <div class="app-page-content">
    <form [formGroup]="form" autocomplete="off">
      <div class="row panels-row">
        <!-- part 1  messageInformation -->
        <section class="xl:tw-w-1/3">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-message-cog tw-ml-2"></i>
              {{ pageVocabs + "legends.smsSetting" | translate }}
            </legend>

            <div
              class="tw-flex tw-justify-between tw-items-center flex-column tw-h-full"
            >
              <div>
                <!-- alert -->
                <div class="alert alert-white border tw-mb-5 tw-mt-1">
                  <p class="tw-mb-1 tw-text-justify tw-font-medium">
                    {{
                      "pages.sendingSystem.sendP2PSms.createExcel" | translate
                    }}
                  </p>
                  <p
                    class="text-danger tw-mt-1 tw-mb-0 tw-text-justify tw-font-medium"
                  >
                    *
                    {{
                      "pages.sendingSystem.sendP2PSms.tipsForExcelTable"
                        | translate
                    }}
                  </p>
                </div>

                <!-- senderNumberId -->
                <private-number-select-search
                  class="tw-w-full"
                  label="common.senderNumberId"
                  [sendType]="SendTypes.P2P"
                  [useType]="UseTypes.Normal"
                  [control]="form?.get('senderNumberId')"
                  [isShowRefreshBtn]="true"
                  [(value)]="model.senderNumberId"
                  (itemChange)="isCanSendFlashSms = $event?.isCanSendFlashSms"
                >
                </private-number-select-search>

                <!-- p2p-file-uploader -->
                <div class="tw-mt-2">
                  <file-uploader
                    [label]="'common.file' | translate"
                    [control]="form?.get('inputFile')"
                    [loading]="loading"
                    [progress]="progress"
                    class="tw-w-[275px]"
                    (valueChange)="readFile($event)"
                    (onClearFile)="previewModel = null"
                    acceptFile=".xls,.xlsx,.csv"
                    [maxFileSize]="500"
                    sizeType="mb"
                    (onErrorFile)="showErrorDialog($event)"
                  >
                  </file-uploader>
                </div>

                <!-- date time picker -->
                <div class="tw-mt-2">
                  <app-date-time-picker
                    [config]="directDateTimeConfig"
                    (dateTime)="model.sendDateTime = $event"
                  >
                  </app-date-time-picker>
                </div>

                <!-- description -->
                <form-textarea
                  class="tw-w-full tw-mt-1"
                  label="common.description"
                  [(value)]="model.description"
                  [control]="form?.get('description')"
                  [rows]="1"
                >
                </form-textarea>

                <!-- isFlashSms -->
                <div
                  class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] tw-mt-2"
                  *ngIf="isCanSendFlashSms"
                >
                  <mat-slide-toggle
                    [(ngModel)]="model.isFlashSms"
                    formControlName="isFlashSms"
                  >
                    {{ "common.isFlashSms" | translate }}
                  </mat-slide-toggle>
                </div>
                <!-- isSendDuplicateNumber -->
                <div class="alert alert-danger tw-text-justify tw-mt-3">
                  <i
                    class="mdi mdi-alert-circle-outline mdi-22px tw-mx-2 text-danger"
                  ></i>
                  <span
                    class="text-danger tw-font-medium"
                    [innerHTML]="
                      'pages.sendingSystem.sendP2PSms.sendWithDuplicateNumbersMsg'
                        | translate
                    "
                  >
                  </span>
                  <div class="checkbox-section tw-mt-3">
                    <mat-slide-toggle
                      [(ngModel)]="model.isSendDuplicateNumber"
                      formControlName="isSendDuplicateNumber"
                      class="tw-font-medium tw-text-gray-800"
                    >
                      {{ "common.sendWithDuplicateNumbers" | translate }}
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </section>

        <!-- part 2  Guide -->
        <div class="xl:tw-w-2/3">
          <app-p2p-sms-body-generator
            class="tw-h-full"
            [columnNames]="importedColList"
            [finalColumnNames]="finalImportedColList"
            [previewModel]="previewModel"
            (pattern)="model.pattern = $event"
            [loading]="loading"
            (toNumberFieldName)="model.toNumberFieldName = $event"
            (form)="smsBodyGenerator = $event"
          >
          </app-p2p-sms-body-generator>
        </div>
      </div>

      <div class="row tw-flex tw-justify-end tw-items-center">
        <div class="md:tw-w-1/6">
          <button
            type="submit"
            mat-ripple
            class="btn tw-w-full tw-mt-5 btn-hover-rise"
            (click)="onSubmit()"
            [themeColor]="'btn'"
            [disabled]="loading"
          >
            <ng-container *ngIf="!loading">
              {{ "common.sendSms" | translate }}
              <i class="fas fa-paper-plane tw-text-2xl"></i>
            </ng-container>

            <!-- loading -->
            <ng-container *ngIf="loading">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </ng-container>
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- sendLoading -->
  <app-special-loading *ngIf="sendLoading" special-loading type="sending">
  </app-special-loading>
</app-page-body>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    menuTitle="SendP2pSms"
    (hidePage)="onHideHelpPage()"
    [title]="pageVocabs + 'title'"
  >
  </app-help-page>
</ng-container>
